import qrcode from "qrcode-generator";
import { useMemo } from "react";

/** A QR code as inline SVG. The link may be relative; the code always carries the full address. */
export function Qr({ link, className }: { link: string; className?: string }) {
  const svg = useMemo(() => {
    const qr = qrcode(0, "M");
    qr.addData(new URL(link, location.origin).href);
    qr.make();
    return qr.createSvgTag({ cellSize: 4, margin: 2 });
  }, [link]);
  return <div className={className} dangerouslySetInnerHTML={{ __html: svg }} />;
}
